/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./themeDomains.vue?vue&type=template&id=68129bba&scoped=true"
import script from "./themeDomains.vue?vue&type=script&lang=js"
export * from "./themeDomains.vue?vue&type=script&lang=js"
import style0 from "./themeDomains.vue?vue&type=style&index=0&id=68129bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68129bba",
  null
  
)

export default component.exports